export const JOBS_REPORT_FETCH_STARTED = 'JOBS_REPORT_FETCH_STARTED';
export const JOBS_REPORT_FETCH_COMPLETED = 'JOBS_REPORT_FETCH_COMPLETED';
export const JOBS_REPORT_FETCH_FAILED = 'JOBS_REPORT_FETCH_FAILED';
